/**
 * Enterprise Navigation Overhaul — generic "recently visited pages" for
 * the sidebar's Recent Items section. Deliberately separate from
 * `store/recently-viewed.store.ts` (patient-specific, and its own header
 * comment documents it intentionally does not hook into "frozen,
 * certified modules" like Clinical/Billing) — this store only ever
 * records navigation-registry page visits, never record-level data, so
 * it never needs to reach into any other module.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface RecentPageRef {
  id: string;
  label: string;
  path: string;
}

interface RecentPagesState {
  recent: RecentPageRef[];
  recordVisit: (page: RecentPageRef) => void;
}

export const useRecentPagesStore = create<RecentPagesState>()(
  persist(
    (set) => ({
      recent: [],
      recordVisit: (page) =>
        set((state) => ({
          recent: [page, ...state.recent.filter((entry) => entry.id !== page.id)].slice(0, 10),
        })),
    }),
    { name: 'nexao-recent-pages' },
  ),
);
